import axios from 'axios'

export default {
  all (callback) {
    axios.get('https://jsonplaceholder.typicode.com/users')
    .then(function (response) {
      callback(response.data)
    })
    .catch(function (err) {
      console.log(err)
    })
  },
  create (customer, callback) {
    axios.post('https://jsonplaceholder.typicode.com/users', {
      email: customer.email,
      username: customer.username,
      name: customer.name
    })
    .then(function (response) {
      callback(response.data)
    })
    .catch(function (err) {
      console.log(err)
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/customer.js